import styled from 'styled-components'
import { Box, Flex } from '@nominex/dex-uikit'

export const StyledWarningText = styled.span<{ large?: boolean }>`
  color: ${({ theme }) => theme.colors.burningOrange500};

  font-size: ${({ large }) => (large ? 16 : 14)}px;
  font-weight: ${({ large }) => (large ? 600 : 400)};
  line-height: ${({ large }) => (large ? 26 : 22)}px;
`

export const StyledWarningContainer = styled(Box)`
  background: ${({ theme }) => theme.colors.burningOrange500}1A;
  border: 1px solid ${({ theme }) => theme.colors.burningOrange500};
  border-radius: 12px;
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: 20px 16px;
`

export const AccentBlock = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => `${theme.colors.primary}7F`};
  border-radius: 6px;
  gap: 12px;
  justify-content: center;
  padding: 24px 16px 16px 16px;
`

export const IconWrapper = styled(Flex)<{ bgColor: string; size: string }>`
  align-items: center;
  background-color: ${({ bgColor, theme }) => {
    const themeColor = theme.colors[bgColor]
    return themeColor ? `${themeColor}33` : `${bgColor}33`
  }};
  border-radius: 9999px;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  min-width: ${({ size }) => size};
  justify-content: center;
`
